'use client';
const getLineClamp = (lineClamp)=>{
    return {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: 'vertical'
    };
};

export { getLineClamp };
//# sourceMappingURL=getLineClamp.js.map
